export default __webpack_public_path__ + "static/media/Desert orange1.b02f5b3d.jpg";